import { FC } from 'react';
import { useSnapshot } from 'valtio';
import SeverityBox from '../../common/components/SeverityBox';
import SkeletonLoader from '../components/SkeletonLoader';
import ExecutiveStore from '../stores/executive-store';

const SeverityBoxContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { orgScanInfoBreakdownInfo } = useSnapshot(ExecutiveStore);

  return (
    <SkeletonLoader
      loading={
        !orgScanInfoBreakdownInfo || orgScanInfoBreakdownInfo.totalIssues === 0
      }>
      {orgScanInfoBreakdownInfo && (
        <SeverityBox
          severityBreakDown={{
            appox: orgScanInfoBreakdownInfo.violations.appox,
            critical: orgScanInfoBreakdownInfo.violations.critical,
            high: orgScanInfoBreakdownInfo.violations.high,
            medium: orgScanInfoBreakdownInfo.violations.medium,
          }}
          totalIssues={orgScanInfoBreakdownInfo.totalIssues}
        />
      )}
    </SkeletonLoader>
  );
};

export default SeverityBoxContainer;
